import { EmptyFaqLayoutModule } from './layouts/empty-faq-layout/empty-faq-layout.module';
import { ResponsiveAppModule } from './layouts/responsive-app/responsive-app.module';
import { TableModule } from 'primeng/table';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { OverviewNavComponent } from './overview-nav/overview-nav.component';
import { ScrollableContainerComponent } from './scrollable-container/scrollable-container.component';
import { FullPageWidgetComponent } from './full-page-widget/full-page-widget.component';
import { UserListComponent } from './user-list/user-list.component';
import { AppLayoutComponent } from 'app/_app_modules/layout/app-layout/app-layout.component';
import { OriginalLayoutModule } from '@layout/layouts/original/original-layout.module';
import { EntityDataLayoutModule } from '@layout/layouts/entity-data/entity-data-layout.module';
import { EmptyModule } from '@feature/_app_modules/layout/layouts/empty-layout/empty.module';
import { ListerComponent } from './lister/lister.component';
import {TableColumnAlignmentDirectiveModule} from "@feature/common";

@NgModule({
  declarations: [
    OverviewNavComponent,
    ScrollableContainerComponent,
    FullPageWidgetComponent,
    UserListComponent,
    ListerComponent,
    AppLayoutComponent,
  ],
    imports: [
        CommonModule,
        SharedModule,
        TableModule,
        OriginalLayoutModule,
        EntityDataLayoutModule,
        EmptyModule,
        ResponsiveAppModule,
        EmptyFaqLayoutModule,
        TableColumnAlignmentDirectiveModule
    ],
  providers: [
  ],
  exports: [
    OverviewNavComponent,
    ScrollableContainerComponent,
    FullPageWidgetComponent,
    UserListComponent,
    ListerComponent,
    AppLayoutComponent
  ]
})
export class LayoutModule { }
